<div class="tw-p-2 tw-pb-0">
  <div class="tw-overflow-hidden tw-rounded-lg [img]:tw-w-full">
    <ng-content select="[slot=media]"></ng-content>
  </div>
</div>
